import React from 'react';
import { Slider } from '@homeexchange/design';
import i18n from '../../../../i18n';
export var Guestpoints = function (_a) {
    var _b, _c;
    var gpRange = _a.gpRange, guestpoints = _a.guestpoints, onChange = _a.onChange;
    return (React.createElement(Slider, { defaultValue: [(_b = guestpoints.from) !== null && _b !== void 0 ? _b : gpRange.min, (_c = guestpoints.to) !== null && _c !== void 0 ? _c : gpRange.max], minValue: gpRange.min, maxValue: gpRange.max, onChange: onChange, minValueText: "".concat(gpRange.min), maxValueText: "".concat(gpRange.max), chosenRangeText: i18n.t('search:filter.chosen_range'), typeRange: "GP", hasSuffixMax: true }));
};
export default Guestpoints;
